import { translate } from "../i18n/translate";
import { globalSearchService } from "../services/GlobalSearchService";


export class SearchSortButton {
    private sortOptionCode: string = "a0";
    private totalCount: number = 0;
    private loading: boolean = false;
    private updateCallback: () => void;

    constructor() {
        this.updateCallback = this.updateFromService.bind(this);
        this.init();
        globalSearchService.addObserver(this.updateCallback);
    }

    private init() {
        this.updateFromService();
        this.populateSortOptions();
        this.bindEvents();
    }

    private populateSortOptions() {
        const mostRelevantText : string = translate('Hero.Order.MostRelevant') ?? 'Most Relevant';
        const leastRecentText : string = translate('Hero.Order.LeastRecent') ?? 'Least Recent';
        const mostRecentText : string = translate('Hero.Order.MostRecent') ?? 'Most Recent';
        const sortTitleAscendingText : string = translate('Hero.Order.TitleAZ') ?? 'Title (A-Z)';
        const sortTitleDescendingText : string = translate('Hero.Order.TitleZA') ?? 'Title (Z-A)';

        const sortOptions : {[key: string]: string} = {
            'a0': mostRelevantText,
            'a1': leastRecentText,
            'd1': mostRecentText,
            'a2': sortTitleAscendingText,
            'd2': sortTitleDescendingText
        };

        this.updateSortButtonDisplay();
        
        const sortOptionsList = document.getElementById('sort-options-list');
        if (!sortOptionsList) return;

        sortOptionsList.innerHTML = '';
        Object.keys(sortOptions).forEach((code : string) => {
            const li = document.createElement('li');
            li.className = this.sortOptionCode === code ? 'active' : '';
            li.dataset.code = code;

            const a = document.createElement('a');
            a.href = '#';
            a.textContent = sortOptions[code];
            a.addEventListener('click', () => {
                let orderBy = 0;
                let orderByAsc = true;

                switch (code) {
                    case "a0":
                        orderBy = 0;
                        orderByAsc = true;
                        break;
                    case "a1":
                        orderBy = 1;
                        orderByAsc = true;
                        break;
                    case "d1":
                        orderBy = 1;
                        orderByAsc = false;
                        break;
                    case "a2":
                        orderBy = 2;
                        orderByAsc = true;
                        break;
                    case "d2":
                        orderBy = 2;
                        orderByAsc = false;
                        break;
                    default:
                }
                
                this.sortOptionCode = code;
                this.updateSortButtonDisplay();
                this.updateActiveOption();
                
                globalSearchService.setFilters({...globalSearchService.filters, orderBy, orderByAsc});
                globalSearchService.refreshSearch();
            })

            li.appendChild(a);
            sortOptionsList.appendChild(li);
        });

        
    }

    private updateFromService(): void {
        const currentOrderBy = globalSearchService.filters.orderBy;
        const currentOrderByAsc = globalSearchService.filters.orderByAsc;
        
        let newSortCode = "a0";
        
        switch (currentOrderBy) {
            case 0:
                newSortCode = "a0";
                break;
            case 1:
                newSortCode = currentOrderByAsc ? "a1" : "d1";
                break;
            case 2:
                newSortCode = currentOrderByAsc ? "a2" : "d2";
                break;
        }
        
        if (this.sortOptionCode !== newSortCode) {
            this.sortOptionCode = newSortCode;
            this.updateSortButtonDisplay();
            this.updateActiveOption();
        }
    }

    private updateSortButtonDisplay(): void {
        const mostRelevantText = translate('Hero.Order.MostRelevant') ?? 'Most Relevant';
        const leastRecentText = translate('Hero.Order.LeastRecent') ?? 'Least Recent';
        const mostRecentText = translate('Hero.Order.MostRecent') ?? 'Most Recent';
        const sortTitleAscendingText = translate('Hero.Order.TitleAZ') ?? 'Title (A-Z)';
        const sortTitleDescendingText = translate('Hero.Order.TitleZA') ?? 'Title (Z-A)';

        const sortOptions: { [key: string]: string } = {
            'a0': mostRelevantText,
            'a1': leastRecentText,
            'd1': mostRecentText,
            'a2': sortTitleAscendingText,
            'd2': sortTitleDescendingText
        };

        const sortButton = document.getElementById('sort-button') as HTMLButtonElement;
        const sortButtonText = document.getElementById('sort-button-text');
        const label = sortOptions[this.sortOptionCode];
        if (sortButtonText) {
            sortButtonText.textContent = label;
        } else if (sortButton) {
            sortButton.innerText = label;
        }
    }

    private updateActiveOption(): void {
        const sortOptionsList = document.getElementById('sort-options-list');
        if (!sortOptionsList) return;

        const allOptions = sortOptionsList.querySelectorAll('li');
        allOptions.forEach(li => {
            const code = li.dataset.code;
            if (code === this.sortOptionCode) {
                li.className = 'active';
            } else {
                li.className = '';
            }
        });
    }

    private bindEvents() {
        const sortDropdownToggle = document.getElementById('sort-dropdown-toggle') as HTMLButtonElement;

        sortDropdownToggle?.addEventListener('click', () => {
            const expanded = sortDropdownToggle.getAttribute('aria-expanded') === 'true';
            sortDropdownToggle.setAttribute('aria-expanded', (!expanded).toString());
        });

        if (sortDropdownToggle) {
            sortDropdownToggle.disabled = this.loading || this.totalCount < 2;
        }
    }

    public destroy(): void {
        globalSearchService.removeObserver(this.updateCallback);
    }

    public updateState(): void {
        this.updateFromService();
    }


}